import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const SftpWriterForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="sftpWriterFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="sftpWriterFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="sftpWriterFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="sftpWriterFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Format"
        error={errors?.format?.message}
      />
      <FormField
        controlId="sftpWriterFormDebug"
        label="debug"
        name="properties.debug"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors?.properties?.debug?.message}
      />
      <FormField
        controlId="sftpWriterFormCredentialType"
        label="credentialType"
        name="properties.credentialType"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Credential Type"
        error={errors?.properties?.credentialType?.message}
      />
      <FormField
        controlId="sftpWriterFormHost"
        label="host"
        name="properties.host"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Host"
        error={errors?.properties?.host?.message}
      />
      <FormField
        controlId="sftpWriterFormUser"
        label="user"
        name="properties.user"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter User"
        error={errors?.properties?.user?.message}
      />
      <FormField
        controlId="sftpWriterFormPassword"
        label="password"
        name="properties.password"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter Password"
        error={errors?.properties?.password?.message}
      />
      <FormField
        controlId="sftpWriterFormPrivateKey"
        label="privateKey"
        name="properties.privateKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXTAREA}
        placeholder="Enter Private Key"
        rows={10}
        error={errors?.properties?.privateKey?.message}
      />
      <FormField
        controlId="sftpWriterFormPassphrase"
        label="passphrase"
        name="properties.passphrase"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Passphrase"
        error={errors?.properties?.passphrase?.message}
      />
      <FormField
        controlId="sftpWriterFormPort"
        label="port"
        name="properties.port"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Port"
        error={errors?.properties?.port?.message}
      />
      <FormField
        controlId="sftpWriterFormPath"
        label="path"
        name="properties.path"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Path"
        required
        error={errors?.properties?.path?.message}
      />
      <FormField
        controlId="sftpWriterFormWriteLevel"
        label="writeLevel"
        name="properties.writeLevel"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Write Level"
        error={errors?.properties?.writeLevel?.message}
      />
      <FormField
        controlId="sftpWriterFormFileName"
        label="fileName"
        name="properties.fileName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter File Name"
        error={errors?.properties?.fileName?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default SftpWriterForm;
